import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import {
  createContext,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

export const TeamMemberFilterContext = createContext<{
  selectedMemberEmail?: string;
  setSelectedMemberEmail: (email?: string) => void;
  startDate?: string;
  setStartDate: (date?: string) => void;
  endDate?: string;
  setEndDate: (date?: string) => void;
}>({
  selectedMemberEmail: undefined,
  setSelectedMemberEmail: () => {},
  startDate: undefined,
  setStartDate: () => {},
  endDate: undefined,
  setEndDate: () => {},
});

export function TeamMemberFilterProvider({ children }: PropsWithChildren) {
  const { data } = useCurrentSubscriptionApi();
  const [selectedMemberEmail, setSelectedMemberEmail] = useState<
    string | undefined
  >();
  const [startDate, setStartDate] = useState<string | undefined>();
  const [endDate, setEndDate] = useState<string | undefined>();

  useEffect(() => {
    if (data?.current && !startDate && !endDate) {
      setStartDate(data.current.currentPeriodStart);
      setEndDate(data.current.currentPeriodEnd);
    }
  }, [data, startDate, endDate]);

  const value = useMemo(
    () => ({
      selectedMemberEmail,
      setSelectedMemberEmail,
      startDate,
      setStartDate,
      endDate,
      setEndDate,
    }),
    [selectedMemberEmail, startDate, endDate]
  );

  return (
    <TeamMemberFilterContext.Provider value={value}>
      {children}
    </TeamMemberFilterContext.Provider>
  );
}

export const useTeamMemberFilter = () => useContext(TeamMemberFilterContext);
